import React, { useState } from "react";
import { Sheet, Button, Field, useInputStyle, useMoney, formatDate } from "../ui";
import { useTheme } from "../../theme/ThemeContext";

// A bill whose amount changes each time (electricity, water, a card bill) asks for the
// actual amount when it's marked paid; the estimate is filled in to start with.
const PaidAmountSheet = ({ bill, data, onClose }) => {
  const { tokens } = useTheme();
  const input = useInputStyle();
  const money = useMoney();
  const [amount, setAmount] = useState(String(bill.amount));
  const [error, setError] = useState("");

  const save = () => {
    const n = parseFloat(amount);
    if (Number.isNaN(n) || n < 0) return setError("Enter the amount you paid.");
    data.update("bills", bill.id, { status: "Paid", amount: n });
    onClose();
  };

  return (
    <Sheet title={`Paid ${bill.payee}`} onClose={onClose}>
      <p style={{ margin: "0 0 14px", fontSize: 13, color: tokens.textMuted }}>
        This bill's amount changes each time. It was estimated at {money(bill.amount)} for {formatDate(bill.dueDate)}; enter what you actually paid. The next one is estimated from your last few payments.
      </p>
      <Field label="Amount paid (₹)">
        <input style={input} type="number" inputMode="decimal" autoFocus value={amount} onChange={(e) => setAmount(e.target.value)} />
      </Field>
      {error && <div role="alert" style={{ marginBottom: 10, fontSize: 13, color: tokens.negative }}>{error}</div>}
      <Button onClick={save} style={{ width: "100%" }}>Mark as paid</Button>
    </Sheet>
  );
};

// `pay(bill)` marks a bill paid, asking for the amount first when it changes each time;
// render `sheet` somewhere on the screen for that question.
export const usePayBill = (data) => {
  const [asking, setAsking] = useState(null);
  const pay = (bill) => (bill.variableAmount ? setAsking(bill) : data.update("bills", bill.id, { status: "Paid" }));
  const sheet = asking ? <PaidAmountSheet bill={asking} data={data} onClose={() => setAsking(null)} /> : null;
  return { pay, sheet };
};

// How a bill's amount reads: an estimate ("~₹1,850") until a varying one is paid.
export const billAmountText = (bill, money) => (bill.variableAmount && bill.status !== "Paid" ? `~${money(bill.amount)}` : money(bill.amount));

export default PaidAmountSheet;
